import { useEffect, useState } from "react";

import "./header.css";

import { Link, useLocation, useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useAuth } from "../../contexts/AuthProvider";
import { switchTenant, hasSession } from "../../config/tenants";

import { AiOutlineMenu } from "react-icons/ai";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPowerOff, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import Pathfind from "../../imgs/Pathfind.png"

export default function Header(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { tenant, tenants, logout, userName } = useAuth();

  const [isNavTreeviewVisible, setNavTreeviewVisible] = useState(false);
  const [name, setName] = useState("");
  const [title, setTitle] = useState("");

  useEffect(() => {
    setTitle(props.title);
    if (location && location.state && location.state.username) {
      setName(location.state.username);
    }
  }, [location]);

  const handleLogout = () => {
    // Encerra só a sessão do cliente ativo
    logout();
    // Redirecionar para a página de login
    navigate("/login");
  };
  

  const toggleNavTreeview = () => {
    setNavTreeviewVisible(!isNavTreeviewVisible);
  };

  return (
    <>
    <nav className="main-header navbar navbar-expand navbar-white navbar-light">
      <ul className="navbar-nav">
        <li className="nav-item">
          <a className="nav-link" data-widget="pushmenu" href="#" role="button"><AiOutlineMenu/></a>
        </li>
        <li className="nav-item d-flex h-25">
            <Link className="nav-link">
              {title}
            </Link>
          </li>
      </ul>
      <ul className="navbar-nav ml-auto align-items-center">
        {tenant && tenant.name && (
          <li className="nav-item mr-3">
            {tenants.length > 1 ? (
              <Dropdown align="end">
                <Dropdown.Toggle variant="outline-secondary" size="sm" id="tenant-switcher">
                  {tenant.name}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {tenants.map((t) => (
                    <Dropdown.Item
                      key={t.slug}
                      active={t.slug === tenant.slug}
                      onClick={() => t.slug !== tenant.slug && switchTenant(t.slug)}
                    >
                      {t.name}
                      {t.slug !== tenant.slug && hasSession(t.slug) ? " ●" : ""}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <span className="badge badge-secondary p-2">{tenant.name}</span>
            )}
          </li>
        )}
        <li className="nav-item h-25">
          <button
            className="d-flex justify-content-center btn btn-white border border-dark mr-4"
            onClick={handleLogout}
          >
            <a href='/login' className='text-dark'>
              <FontAwesomeIcon icon={faPowerOff} className='pr-2 text-dark'/>
              Sair
            </a>
          </button>
        </li>
      </ul>
    </nav>




    <aside className="main-sidebar sidebar-light-primary elevation-4">
      <a className="brand-link d-flex justify-content-center">
        <img src={Pathfind} className="brand-image img-fluid"></img>
      </a>
      <div className="sidebar">
        <div className="user-panel mt-5 mb-5 d-flex custom-userbox">
          <div className="info">
            <a className="d-block">{userName}</a>
          </div>
        </div>
        <nav className="mt-2">
          <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
            <li className="nav-item">
                  <Link to={`/user`} className="nav-link">
                  <i class="nav-icon fas fa-regular fa-table"></i>
                    <p style={{alignItems:'center'}}>
                      Gerenciamento
                    </p>
                  </Link>
                </li>
                <nav className="mt-2">
                <ul
                  className="nav nav-pills nav-sidebar flex-column"
                  data-widget="treeview"
                  role="menu"
                  data-accordion="false"
                >
                  <li
                    className={`nav-item has-treeview ${
                      isNavTreeviewVisible ? "menu-open" : ""
                    }`}
                  >
                    <a href="#" className="nav-link" onClick={toggleNavTreeview}>
                      <i class="nav-icon fa-solid fa-file"></i>
                      <p>
                        Histórico Integrações
                        <i className="right fas fa-angle-left" style={{ marginLeft: '10px' }}></i>
                      </p>
                    </a>
                    <ul
                      className={`nav nav-treeview ${
                        isNavTreeviewVisible ? "show" : ""
                      }`}
                    >
                      <li className="nav-item">
                          <Link to={`/logs_pathfind`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Logs Pathfind</p>
                          </Link>
                      </li>
                      <li className="nav-item">
                          <Link to={`/logs_sankhya`} className="nav-link">
                            <i className="far fa-circle nav-icon"></i>
                            <p>Logs Sankhya</p>
                          </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
          </ul>
        </nav>
        <div style={{position: "absolute", bottom: 0, left: 10, marginBottom: 5}} >
            Version: 1.0.0 <br/>
            Data: 29/11/2024
        </div>
      </div>
    </aside>
    </>
  );
}